import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { Modal } from '@modals/core-ui/Modal';

import { ModalWrapper } from './styles/ModalWrapper';
import { TProps } from './types/TProps';

export const AgreementModal = ({ isOpen, setIsOpen }: TProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <ModalWrapper>
        <iframe src="/agreement.html" title="agreement" width="100%" height="100%" frameBorder={0} />
        <Button className="closeButton" onClick={() => setIsOpen(false)}>
          Close
        </Button>
      </ModalWrapper>
    </Modal>
  );
};
